import { Component, OnChanges,Input,Output,EventEmitter, NgZone} from '@angular/core';
import { LoadingService } from '../../share/service/loading.service';
import { ApiService } from '../../share/service/api.service';
import { Router} from '@angular/router';
declare var tippy;
declare var $;
declare var jslib;
@Component({
  selector: 'buyerCard',
  templateUrl: './buyerCard.component.html'
})
export class buyerCardComponent implements OnChanges 
{
  @Input() Data;
  @Output() Event = new EventEmitter();
  IsLogin = false;
  constructor(
    private pop : LoadingService,
    private baseapi : ApiService,
    public ngzone : NgZone,
    public route: Router
  ) {
  }

  ngOnChanges() {
    this.IsLogin = jslib.GetStorage('user') != null;
  }
  FavToggle(event){
    event.preventDefault();
    event.stopPropagation();
    var islogin = this.baseapi.IsLogin();
    if(islogin){
      var query = {
        event_id: this.Data.event_id,
        buyer_id:this.Data.buyer_id,
        remove:this.Data.favorite
      };
      this.baseapi.apiGet('v1/member/favoriteAddRemove',query).then(
        (res)=>{
          this.Data.favorite = !this.Data.favorite;
        });
    }else{
      this.pop.setConfirm({
        content:'請先登入後<br/>再進行買主儲存',
        cancelTxt:'取消',
        checkTxt:'前往登入',
        event:()=>{
          //轉往登入
          this.baseapi.RedirectSSO();
        }
      });
    }
  }

  DirectTo(){
    //2025/02/20 by Simon 買主另開分頁
    window.open('/member/signTime/' + this.Data['buyer_id']);
    //this.route.navigateByUrl('/member/signTime/' + this.Data['buyer_id']);
  }
  DirectLogin(){
    this.baseapi.RedirectSSO();
  }
  DownloadFile(prod){
    console.log('DownloadFile',prod);
    var _url = '/brochure/download?buyer_id=' + this.Data.buyer_id + '&product_id=' + prod.id;
    window.open(_url, "_blank");
  }
  
}
